import { Injectable } from '@angular/core';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { RoleDetailsViewModel } from './../business-entities/role-details-view-model';


@Injectable({ providedIn: 'root' })
export class RolesRightsDataService {
    constructor(
        private dataProvider: DataService
    ) { }

    getRoles(): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<any>(Urls.GetRoles).toPromise();
    }

    getRoleDetails(id: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<any>(Urls.GetRoleDetails, id).toPromise();
    }

    saveRoleRights(roleDetails: RoleDetailsViewModel): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Put<any>(Urls.UpdateRoleDetails, roleDetails).toPromise();
    }
    getFeatures(): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<any>(Urls.GetFeature).toPromise();
    }
    getFeatureByDealerId(featureCode:string,dealerId:string,brandCode:string): Promise<any>{
        return this.dataProvider.Get<any>(Urls.GetFeature,featureCode,dealerId,brandCode).toPromise();
    }
    updateFeature(model:any): Promise<any>{
        return this.dataProvider.Put<any>(Urls.UpdateFeature, model).toPromise();
    }
    getRoleList(): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<any>(Urls.GetRolesToAddUser).toPromise();
    }

    getEmployeeList(employeeListRequestModel):Promise<GenericResponse<any>>{
        return this.dataProvider.Post<any>(Urls.GetEmployee,employeeListRequestModel).toPromise();
    }
    AddRole(RoleModel: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<any>(Urls.AddRole ,RoleModel).toPromise();
    }
    GetApplicationList(): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<any>(Urls.GetApplicationList).toPromise();
    }
    updateStampInOutFeature(role:any): Promise<any>{
        return this.dataProvider.Put<any>(Urls.UpdateStampInFeature,role).toPromise();
    }
}